import { TableCell, TableRow, Typography } from '@material-ui/core'

import { TABLE_TEXT } from './ExtensionsTable'

const EmptyStateRow = () => {
  return (
    <TableRow>
      <TableCell>
        <Typography variant="body1">{TABLE_TEXT.noExtensions}</Typography>
      </TableCell>
    </TableRow>
  )
}

export default EmptyStateRow
